import moment from 'moment'
import FrontOfficeLabel from "@/Lib/Labels/FrontOfficeLabel";
export default class Label {
    constructor(dymo){
        this.dymo = dymo;
        this.label = null;
        this.labelSet = null;
        this.printer = null;
        this.init();
    }

    init(){
        console.log("Init label class")
        this.dymo.label.framework.trace=1;
        this.dymo.label.framework.init();
    }
    printers() {
        return this.dymo.label.framework.getLabelWriterPrinters();
    }

    setPrinter(){
        console.log("Selecting printer")
        let printer = this.printers();
        if(printer.length > 0){
            this.printer = printer[0].modelName;
        }
    }
    setLabel(label){
        console.log("Setting label type...")
        this.label = this.dymo.label.framework.openLabelXml(label);
    }
    
    createLabels(samples, many = false){
        console.log("Create labels")
        this.labelSet = new this.dymo.label.framework.LabelSetBuilder();
        if(!many){
            console.log('Creating single sample:', samples)
            this.setLabelKeys(samples)
        }else{
            console.log("Creating many samples:", samples)
            for(let i = 0; i<samples.length;i+=1){
                this.setLabelKeys(samples[i]);
            }
        }
    }
    setLabelKeys(sample){
        console.log("Adding Sample to Set:", sample)
        const sampleId = sample.id;
        const pending = sampleId.includes("PENDING-") ? sampleId.replace('PENDING-', '') : '  '
        console.log(sample.short_id, 'print');
        const sampleTests = [...new Set(sample.required_tests.map(test => test.test_type))].join(' ');
        const record = this.labelSet.addRecord();
        record.setText("BARCODE_1", sample.uuid);
        // record.setText("BARCODE_2", sample.uuid);
        record.setText("LOT_1", sample.lot);
        // record.setText("LOT_2", sample.lot);
        record.setText("PENDING_1", pending);
        // record.setText("PENDING_2", pending);
        // record.setText("SAMPLE_TESTS", sampleTests);
        record.setText("TESTS_1", sampleTests);
    }
    
    // label.setObjectText("BARCODE_1", 5050001);
    // label.setObjectText("BARCODE_2", 50500001);
    // label.setObjectText("SAMPLENUM_1", "50500001");
    // label.setObjectText("SAMPLENUM_2", "50500001");
    // label.setObjectText("NAME_1", "DEVIN");
    // label.setObjectText("NAME_2", "DEVIN");
    // label.setObjectText("PRE_CODE_1", "505");
    // label.setObjectText("PRE_CODE_2", "505");
    // label.setObjectText("TRAYWELL_1", "1");
    // label.setObjectText("TRAYWELL_2", "1");
    // label.setObjectText("TYPE_1", "FLOWER");
    // label.setObjectText("TYPE_2", "FLOWER");
    // label.setObjectText("DATE_1", "date");
    // label.setObjectText("DATE_2", "date");

    print(){
        return new Promise((resolve, reject) => {
            console.log("Attempting to print")
            try{
                if(this.printer !== null){
                    this.label.print(this.printer, '', this.labelSet);
                    resolve({res: true, message: 'Printed!'})
                }else{
                    resolve({res: false, message: 'No printer found'})
                }
            }catch(error){
                reject({res: false, message: error})
            }
        })
    }

}
